import React, { useEffect, useRef, useState } from 'react';

import styles from './ProductAnalogyCard.module.css'
import { DeliveryPoint } from "../DeliveryPoint/DeliveryPoint.tsx";
import { ProductCard as ProductCardInterface } from "../ProductCard/types/productCard.interface.ts";
import "yet-another-react-lightbox/styles.css";
import { ImgCarousel } from '../ImgCarousel/ImgCarousel.tsx';
import { API_URL } from '../../config.tsx';
import { addToCartPublisher } from '@/utils/storage/extra/loaders/cart/addToCartPublisher.ts';
import { useAppDispatch } from '@/utils/storage/stores/store.ts';
import { useSearchParams } from 'react-router-dom';

interface Props {
    productId: number,
    branchId: number,
    increaseLoadingAnalogsCount: (id: number) => void,
}

export const ProductAnalogyCard: React.FC<Props> = ({
    productId,
    branchId,
    increaseLoadingAnalogsCount,
}) => {
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const [product, setProduct] = useState<ProductCardInterface | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [openImg, setOpenImg] = React.useState(false);
    const cardRef = useRef<HTMLDivElement | null>(null);

    const setProductData = (productId: number, branchId: number) => {
        fetch(`${API_URL}/product_public_info/${productId}?branchId=${branchId}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => setProduct(data))
            .then(() => setIsLoading(false))
            .then(() => increaseLoadingAnalogsCount(productId))
    }

    useEffect(() => {
        setProductData(productId, branchId);
    }, [branchId]);

    /** Добавление товара в корзину */
    const addProductToCart = (cartId: number, itemId: number) => {
        const elementId = searchParams.get('elementId') || '';
        dispatch(addToCartPublisher({ cartId, itemId, elementId}));
    };

    if (isLoading) return null;

    return product
        ? (
            <div className='bg-[#fafbfc] rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row mb-6 items-stretch shadow-md'
                ref={cardRef} style={{ scrollMarginTop: '3rem' }}>
                <div className='w-full sm:w-88 flex-shrink-0 flex justify-center mb-4 sm:mb-0'>
                    <div className='w-full'>
                        <div className='flex mt-4 flex-col sm:flex-row'>
                            <img className='w-full sm:self-center mb-4 max-w-[160px] h-[120px] sm:h-[160px] object-cover rounded-2xl cursor-pointer transition-transform hover:scale-105 shadow-lg'
                                src={product.img_thumbnail}
                                alt={'Изображение ' + product.name}
                                onClick={() => setOpenImg(true)} />
                            <div className='flex flex-col sm:w-48 justify-center pl-4 sm:pl-0 mb-4 sm:mb-0'>
                                <p className='font-bold text-base'>{product.brand}</p>
                                <a className='text-[#F39200] underline font-bold'
                                    href={`/spares/${product.brandSlug}/${product.article}`}>{product.article}</a>
                                <p className='font-bold mb-1'>{product.name}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {openImg && <ImgCarousel images={[{ id: product.productId, url: product.img }]}
                    showCarousel={openImg}
                    setShowCarousel={setOpenImg} />}
                {
                    product.deliveryPoint && product.deliveryPoint.offers.length
                        ? <DeliveryPoint
                            addProductToCart={addProductToCart}
                            point={product.deliveryPoint}
                            showCount={2}
                            cardRef={cardRef}
                        />
                        : null
                }
            </div>
        ) : <div className={styles.card}>
            <img className={styles.image} src="/img/nopic.jpg" />
        </div>;
};
